import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({
    project,
    projectResource,
    hasRequestedAllocationTransfer,
    destinationResource,
    tasks,
  }) =>
    present(
      (hasRequestedAllocationTransfer
        ? repository.removeResourceFromProjectAndTransferAllocations(
            project,
            projectResource,
            destinationResource,
            tasks,
          )
        : repository.removeResourceFromProject(project, projectResource)
      )
        .then(() => ({
          project,
          projectResource,
          hasRequestedAllocationTransfer,
          destinationResource,
          tasks,
        }))
        .catch(() =>
          Promise.reject({
            project,
            projectResource,
            hasRequestedAllocationTransfer,
            destinationResource,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
